import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';

import './SignIn.scss';
import Modal from '../../shared/Modal';
import FormPupLogo from '../../../images/form-pup-text-logo.png';
import { authCodesMap } from '../authCodesMap';

function SignIn({}) {
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [modalText, setModalText] = useState('');

  const signIn = async (e) => {
    e.preventDefault();

    try {
      const auth = getAuth();
      await signInWithEmailAndPassword(auth, email, password);
      history.push('/');
    } catch (e) {
      const errorMessage = authCodesMap[e.code] || 'An error occurred signing you in. Please try again.';
      setModalTitle('Error:');
      setModalText(errorMessage);
    }
  };

  return (
    <div className="SignIn">
      <div className="form-container">
        <div className="well auth-well">
          <div className="logo-container">
            <img
              src={FormPupLogo}
              alt="Form Pup Logo"
              className="logo"
            />
          </div>

          <h1>Sign In</h1>

          <form onSubmit={signIn}>
            <div className="input-container">
              <label>Email:</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter email"
              />
            </div>

            <div className="input-container">
              <label>Password:</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
              />
            </div>

            <button
              type="submit"
            >
              Sign In
            </button>
          </form>

          <div className="forgot-password-link-container">
            <Link to="/forgot-password">
              Forgot Password
            </Link>
          </div>

          <div className="or-container">
            <div className="or-divider"></div>
            <p>[OR]</p>
            <div className="or-divider"></div>
          </div>

          <div className="create-account-button-container">
            <Link to="/signup">
              <button className="alternate">
                Create Account
              </button>
            </Link>
          </div>

          <div className="terms-container">
            <div className="terms-container-inner">
              <a href="https://formpup.com/terms-conditions/">
                Terms of Use
              </a>
              <p className="terms-divider">|</p>
              <a href="https://formpup.com/privacy-policy/">
                Privacy Policy
              </a>
            </div>
          </div>

          <div className="copyright-container">
            <p>Copyright © {new Date().getFullYear()}, Form Pup LLC - All Rights Reserved</p>
          </div>
        </div>
      </div>

      <Modal
        open={!!modalText}
        close={() => {
          setModalTitle('');
          setModalText('');
        }}
        title={modalTitle}
        buttons={[
          <button key="modal-close" className="small" onClick={() => {
            setModalTitle('');
            setModalText('');
          }}>Close</button>,
        ]}
      >
        <div>
          <div className="modal-text">{modalText}</div>
        </div>
      </Modal>
    </div>
  );
}

export default SignIn;
